(function () {
  "use strict";

  var config = window.KB_LEADS_CONFIG || {};
  var API_COLLECT = config.collectUrl || "https://app.fordservisbeograd.rs/leads/lead_collect.php";
  var API_EVENT = config.eventUrl || "https://app.fordservisbeograd.rs/leads/lead_event.php";

  var LS_ANON_ID = "gs_anon_id";
  var LS_LEAD_ID = "gs_lead_id";
  var LS_QUEUE = "gs_event_queue";
  var LS_SESSION = "gs_session_id";
  var LS_LAST_ACTIVITY = "gs_last_activity";
  var LS_HAS_REAL_EMAIL = "gs_has_real_email";
  var LS_SKIP_UNTIL = "gs_popup_skip_until";
  var LS_HIDE_HELP = "gs_hide_help_popup";
  var LS_PHONE_IDENTIFIED = "gs_phone_identified";
  var LS_RECOMMENDED_PRODUCTS = "recommended_products";
  var LS_LAST_POPUP_SHOWN_AT = "gs_last_popup_shown_at";
  var LS_CART_POPUP_CLOSED_UNTIL = "gs_cart_popup_closed_until";
  var LS_FREE_DELIVERY_POPUP_CLOSED_UNTIL = "gs_free_delivery_popup_closed_until";
  var SS_COUPON_NOTICE = "kb_coupon_notice";

  var SESSION_TIMEOUT_MS = 30 * 60 * 1000;
  var POPUP_SKIP_MS = 60 * 60 * 1000;
  var GLOBAL_POPUP_COOLDOWN_MS = config.globalPopupCooldownMs || 60 * 1000;
  var CART_POPUP_COOLDOWN_MS = config.cartPopupCooldownMs || 30 * 60 * 1000;
  var FREE_DELIVERY_POPUP_COOLDOWN_MS = config.freeDeliveryPopupCooldownMs || 30 * 60 * 1000;
  var CART_DISCOUNT_THRESHOLD = config.cartDiscountThreshold || 5499;
  var MIN_CART_TOTAL_TO_SHOW_CART_DISCOUNT = config.minCartTotalToShowCartDiscount || 1500;
  var FREE_SHIPPING_THRESHOLD = config.freeShippingThreshold || 6000;
  var MIN_CART_TOTAL_TO_SHOW_FREE_DELIVERY = config.minCartTotalToShowFreeDelivery || 4000;
  var FREE_DELIVERY_POPUP_ENABLED = config.freeDeliveryPopup === true;
  var CART_DISCOUNT_CODE = config.cartDiscountCode || "MOJDOM";
  var CART_RECOMMENDATION_LIMIT = config.cartRecommendationLimit || 6;
  var DEBUG = config.debug === true;

  function log() {
    if (DEBUG && window.console) console.log.apply(console, arguments);
  }

  function safeJsonParse(value, fallback) {
    try {
      return value ? JSON.parse(value) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function randId(prefix) {
    if (window.crypto && window.crypto.randomUUID) return prefix + window.crypto.randomUUID();
    return prefix + Math.random().toString(36).slice(2) + Date.now();
  }

  function normalizePhone(phone) {
    if (!phone) return "";
    phone = String(phone).replace(/\s+/g, " ").trim();
    var digits = phone.replace(/\D/g, "");
    if (digits.length < 8) return "";
    if (phone === "+381" || phone === "+381 ") return "";
    return phone;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());
  }

  function isGeneratedEmail(email) {
    return String(email || "").trim().toLowerCase().endsWith("@kucnibrojevi.com");
  }

  function rememberContactState(data) {
    data = data || {};
    var email = String(data.email || "").trim().toLowerCase();
    var phone = normalizePhone(data.phone || "");

    if (email && !isGeneratedEmail(email)) {
      localStorage.setItem(LS_HAS_REAL_EMAIL, "1");
      localStorage.setItem("gs_contact_complete", "1");
      localStorage.removeItem(LS_SKIP_UNTIL);
    } else if (phone && localStorage.getItem(LS_HAS_REAL_EMAIL) !== "1") {
      localStorage.setItem("gs_contact_complete", "0");
    }
  }

  function isCheckoutPage() {
    return window.location.pathname.indexOf("/checkouts") !== -1 ||
      window.location.pathname.indexOf("/checkout") !== -1;
  }

  function isCooldownActive(key) {
    var until = parseInt(localStorage.getItem(key) || "0", 10);
    return !!until && Date.now() < until;
  }

  function canShowAnyPopup() {
    if (isCheckoutPage()) return false;
    if (window.kbAnyPopupOpen) return false;

    var lastShownAt = parseInt(localStorage.getItem(LS_LAST_POPUP_SHOWN_AT) || "0", 10);
    if (lastShownAt && Date.now() - lastShownAt < GLOBAL_POPUP_COOLDOWN_MS) return false;

    return true;
  }

  function markPopupShown() {
    localStorage.setItem(LS_LAST_POPUP_SHOWN_AT, String(Date.now()));
    window.kbAnyPopupOpen = true;
  }

  function releasePopupLock() {
    window.kbAnyPopupOpen = false;
  }

  function shouldShowLeadPopup(options) {
    options = options || {};
    if (!canShowAnyPopup()) return false;
    if (localStorage.getItem(LS_HAS_REAL_EMAIL) === "1") return false;
    if (localStorage.getItem(LS_HIDE_HELP) === "1") return false;
    if (isCooldownActive(LS_SKIP_UNTIL)) return false;
    if (config.customilyIntercept === false && options.ignoreCustomilyIntercept !== true) return false;
    return true;
  }

  function needsEmailPopup() {
    return shouldShowLeadPopup();
  }

  function promptForEmailIfNeeded(delayMs) {
    if (!needsEmailPopup()) return;
    setTimeout(function () {
      if (needsEmailPopup() && typeof window.kbShowLeadPopup === "function") {
        window.kbShowLeadPopup();
      }
    }, delayMs || 1200);
  }

  var anonId = localStorage.getItem(LS_ANON_ID);
  if (!anonId) {
    anonId = randId("anon_");
    localStorage.setItem(LS_ANON_ID, anonId);
  }

  var leadId = parseInt(localStorage.getItem(LS_LEAD_ID) || "", 10);
  if (isNaN(leadId)) leadId = null;

  function getSessionId() {
    var now = Date.now();
    var last = parseInt(localStorage.getItem(LS_LAST_ACTIVITY) || "0", 10);
    var sessionId = localStorage.getItem(LS_SESSION);
    if (!sessionId || !last || now - last > SESSION_TIMEOUT_MS) sessionId = randId("sess_");
    localStorage.setItem(LS_SESSION, sessionId);
    localStorage.setItem(LS_LAST_ACTIVITY, String(now));
    return sessionId;
  }

  var sessionId = getSessionId();

  function touchSession() {
    localStorage.setItem(LS_LAST_ACTIVITY, String(Date.now()));
  }

  function handleLeadResponse(res) {
    rememberContactState(res);

    if (res && res.anon_id && res.anon_id !== anonId) {
      anonId = res.anon_id;
      localStorage.setItem(LS_ANON_ID, anonId);
      window.gsAnonId = anonId;
    }

    if (res && res.lead_id) {
      var id = parseInt(res.lead_id, 10);
      if (!isNaN(id)) {
        leadId = id;
        localStorage.setItem(LS_LEAD_ID, String(id));
        window.gsLeadId = id;
        flushQueue();
      }
    }

    return res;
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) {
      return r.json();
    }).catch(function () {
      return {};
    });
  }

  function initLeadOnce() {
    if (leadId) return Promise.resolve(leadId);

    return fetch(API_COLLECT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        anon_id: anonId,
        lead_id: leadId,
        page: window.location.href,
        session_id: sessionId,
        event_type: "init"
      })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(handleLeadResponse)
      .then(function () { return leadId; });
  }

  var queue = safeJsonParse(localStorage.getItem(LS_QUEUE), []);
  if (!Array.isArray(queue)) queue = [];
  var flushInProgress = false;

  function saveQueue() {
    localStorage.setItem(LS_QUEUE, JSON.stringify(queue));
  }

  function enqueueEvent(type, data, page, cart) {
    queue.push({
      type: type,
      data: data || {},
      page: page || window.location.href,
      cart: cart || null,
      ts: new Date().toISOString()
    });
    saveQueue();
  }

  function postEventObject(ev) {
    touchSession();

    var payload = {
      anon_id: anonId,
      lead_id: leadId,
      session_id: sessionId,
      event_type: ev.type,
      event_data: ev.data || {},
      page: ev.page || window.location.href,
      ts: ev.ts || new Date().toISOString(),
      referrer: document.referrer || "",
      ua: navigator.userAgent
    };

    if (ev.cart) payload.cart = ev.cart;

    return fetch(API_EVENT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(handleLeadResponse)
      .catch(function () {
        enqueueEvent(ev.type, ev.data, ev.page, ev.cart);
      });
  }

  function flushQueue() {
    if (flushInProgress || !leadId || !queue.length) return;
    flushInProgress = true;
    var copy = queue.slice();
    queue = [];
    saveQueue();

    (function next(i) {
      if (i >= copy.length) {
        flushInProgress = false;
        return;
      }
      postEventObject(copy[i]).finally(function () { next(i + 1); });
    })(0);
  }

  function sendEvent(type, data, opts) {
    opts = opts || {};
    var event = {
      type: type,
      data: data || {},
      page: opts.page || window.location.href,
      cart: opts.cart || null,
      ts: new Date().toISOString()
    };

    if (!leadId) {
      enqueueEvent(event.type, event.data, event.page, event.cart);
      return;
    }

    postEventObject(event);
  }

  function collectLead(data) {
    data = data || {};
    rememberContactState(data);

    return initLeadOnce()
      .then(fetchCart)
      .then(function (cart) {
        var payload = {
          anon_id: anonId,
          lead_id: leadId,
          ime: data.ime || data.fname || "",
          prezime: data.prezime || data.lname || "",
          email: data.email || "",
          phone: normalizePhone(data.phone || ""),
          cart: cart,
          page: window.location.href,
          session_id: sessionId,
          event_type: data.event_type || "identify",
          extra: data.extra || {}
        };

        return fetch(API_COLLECT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(handleLeadResponse);
  }

  function identifyByPhone(phone, source) {
    phone = normalizePhone(phone || "");
    if (!phone) return Promise.resolve(null);

    if (localStorage.getItem(LS_PHONE_IDENTIFIED) === phone && leadId) {
      promptForEmailIfNeeded();
      return Promise.resolve(leadId);
    }

    return collectLead({
      phone: phone,
      event_type: "identify_phone",
      extra: { source: source || "phone_only" }
    }).then(function (res) {
      localStorage.setItem(LS_PHONE_IDENTIFIED, phone);
      promptForEmailIfNeeded();
      return res;
    });
  }

  function ensureLeadFromCart(cart) {
    cart = cart || {};
    var phone = cart.attributes && typeof cart.attributes.Telefon === "string"
      ? cart.attributes.Telefon.trim()
      : "";

    if (!phone) return Promise.resolve(null);
    return identifyByPhone(phone, "cart_attribute");
  }

  function findScopeWithInputs(el) {
    var node = el;
    var phoneScope = null;

    while (node && node !== document.body) {
      if (node.querySelector) {
        if (node.querySelector("#email, input[type='email']")) return node;
        if (!phoneScope && node.querySelector(".react-international-phone-input, input[type='tel']")) {
          phoneScope = node;
        }
      }
      node = node.parentElement;
    }

    return phoneScope || document;
  }

  function readFields(scope) {
    var root = scope || document;
    var inputs = Array.prototype.slice.call(root.querySelectorAll("input"));

    function bySelector(selector) {
      var el = root.querySelector(selector);
      return el && el.value ? el.value.trim() : "";
    }

    function findValue(predicate) {
      var found = inputs.find(function (input) {
        var h = [
          input.id || "",
          input.name || "",
          input.type || "",
          input.placeholder || "",
          input.getAttribute("aria-label") || "",
          input.className || ""
        ].join(" ").toLowerCase();
        return predicate(input, h);
      });
      return found && found.value ? found.value.trim() : "";
    }

    var fname = bySelector("#first_name") || bySelector("#gsFirstName") ||
      findValue(function (_, h) { return h.includes("first") || h.includes("ime"); });

    var lname = bySelector("#last_name") || bySelector("#gsLastName") ||
      findValue(function (_, h) { return h.includes("last") || h.includes("prezime"); });

    var email = bySelector("#email") || bySelector("#gsEmail") ||
      findValue(function (input, h) { return input.type === "email" || h.includes("email") || h.includes("mail"); }) ||
      ((inputs.find(function (input) { return isValidEmail(input.value || ""); }) || {}).value || "").trim();

    var phone = normalizePhone(window.__kbLastPhone || "") ||
      normalizePhone(bySelector(".react-international-phone-input")) ||
      normalizePhone(bySelector("#gsPhone")) ||
      normalizePhone(findValue(function (input, h) {
        return input.type === "tel" || h.includes("phone") || h.includes("telefon") || h.includes("mobile");
      }));

    return { fname: fname, lname: lname, email: email, phone: phone };
  }

  function injectPopup() {
    if (document.getElementById("gsPopupOverlay")) return;

    var style = document.createElement("style");
    style.textContent = [
      "#gsPopupOverlay{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.48);font-family:inherit;padding:16px;box-sizing:border-box}",
      ".gsPopupContainer{width:min(500px,100%);max-height:calc(100vh - 32px);overflow-y:auto;background:#fff;color:#161616;border:1px solid rgba(0,0,0,.08);border-radius:14px;padding:28px;box-shadow:0 24px 80px rgba(0,0,0,.28);position:relative;box-sizing:border-box}",
      ".gsCloseBtn{position:absolute;right:12px;top:10px;width:38px;height:38px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:30px;line-height:1;color:#222;border-radius:999px}",
      ".gsCloseBtn:hover{background:#f4f4f4}",
      ".gsTitle{margin:0 42px 8px 0;font-size:25px;line-height:1.18;font-weight:700;letter-spacing:0;color:#111}",
      ".gsSubtitle{margin:0 0 20px;color:#555;font-size:15px;line-height:1.45}",
      ".gsInputRow{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px}",
      ".gsEmailWrap{margin-bottom:10px}",
      ".gsInput,.gsPhoneInput{width:100%;box-sizing:border-box;border:1px solid #d7d7d7;border-radius:10px;background:#fff;color:#111;padding:13px 14px;font-size:16px;line-height:1.25;outline:none;transition:border-color .18s,box-shadow .18s}",
      ".gsInput:focus,.gsPhoneInput:focus{border-color:#111;box-shadow:0 0 0 3px rgba(0,0,0,.08)}",
      ".gsPhoneInput{margin-bottom:14px}",
      ".gsButton{width:100%;min-height:48px;border:0;border-radius:999px;background:#111;color:#fff;font-weight:700;cursor:pointer;font-size:15px;line-height:1.2;padding:13px 18px;margin:0 0 10px;transition:transform .16s,opacity .16s,background .16s}",
      ".gsButton:hover{transform:translateY(-1px)}",
      ".gsBtnCart{background:#f3f3f3;color:#555;font-weight:600}",
      ".gsQuickContact{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-top:14px}",
      ".gsQuickBtn{min-height:42px;border-radius:10px;display:flex;align-items:center;justify-content:center;text-decoration:none;font-size:14px;font-weight:700;line-height:1.15;color:#111;background:#f6f6f6;border:1px solid #e4e4e4;box-sizing:border-box;text-align:center;padding:8px}",
      ".gsWhatsApp{background:#edf8f1;border-color:#cfeeda;color:#137a35}",
      ".gsViber{background:#f2effb;border-color:#ded5f5;color:#5b3db4}",
      ".gsCall{background:#fff5ea;border-color:#f3dcc0;color:#a75a0b}",
      "@media(max-width:460px){.gsPopupContainer{padding:24px 18px 18px;border-radius:12px}.gsTitle{font-size:22px;margin-right:38px}.gsSubtitle{font-size:14px}.gsInputRow{grid-template-columns:1fr;gap:0}.gsQuickContact{grid-template-columns:1fr}.gsQuickBtn{justify-content:center;min-height:40px}}",
      "@media(max-width:340px){.gsPopupContainer{padding-left:14px;padding-right:14px}.gsTitle{font-size:20px}.gsButton,.gsQuickBtn{font-size:14px}}"
    ].join("");
    document.head.appendChild(style);

    var overlay = document.createElement("div");
    overlay.id = "gsPopupOverlay";
    overlay.innerHTML = [
      "<div class='gsPopupContainer'>",
      "<div id='gsPopupClose' class='gsCloseBtn' aria-label='Zatvori'>&times;</div>",
      "<div class='gsTitle'>Tu smo da vam pomognemo 👋</div>",
      "<div class='gsSubtitle'>Ostavite kratke podatke i javićemo se uskoro putem Vibera ili emaila.</div>",
      "<div class='gsInputRow'>",
      "<input id='gsFirstName' class='gsInput' placeholder='Ime'>",
      "<input id='gsLastName' class='gsInput' placeholder='Prezime'>",
      "</div>",
      "<div class='gsEmailWrap'>",
      "<input id='gsEmail' class='gsInput' type='email' placeholder='Email adresa'>",
      "</div>",
      "<input id='gsPhone' class='gsPhoneInput' value='+381' placeholder='Broj telefona'>",
      "<button id='gsPopupSubmit' class='gsButton'>Kontaktirajte me</button>",
      "<button id='gsSkipPopup' class='gsButton gsBtnCart'>Nastavi bez unosa</button>",
      "<div class='gsQuickContact'>",
      "<a class='gsQuickBtn gsWhatsApp' href='https://wa.me/381658416212' target='_blank' rel='noopener'>💬 WhatsApp</a>",
      "<a class='gsQuickBtn gsViber' href='viber://chat?number=+381658416212'>📲 Viber</a>",
      "<a class='gsQuickBtn gsCall' href='tel:+381658416212'>📞 Poziv</a>",
      "</div>",
      "</div>"
    ].join("");
    document.body.appendChild(overlay);

    function hide() {
      overlay.style.display = "none";
      window.kbLeadPopupOpen = false;
      releasePopupLock();
    }

    function continuePendingCustomilyClick() {
      if (!window.__kbPendingCustomilyClick) return;
      window.__kbPendingCustomilyClick = false;

      setTimeout(function () {
        var btn = document.getElementById("customily-personalize-button");
        if (btn && btn.offsetParent !== null) btn.click();
      }, 200);
    }

    function getLeadPopupEventData(action, options) {
      options = options || {};
      return {
        popup_type: "lead_help",
        action: action || "",
        source: options.source || "auto",
        url: window.location.href,
        pathname: window.location.pathname,
        has_lead_id: !!leadId
      };
    }

    window.kbShowLeadPopup = function (options) {
      options = options || {};
      if (!shouldShowLeadPopup(options)) return;
      overlay.style.display = "flex";
      window.kbLeadPopupOpen = true;
      markPopupShown();
      sendEvent("lead_popup_shown", getLeadPopupEventData("shown", options));
      setTimeout(function () {
        var firstName = document.getElementById("gsFirstName");
        if (firstName) firstName.focus();
      }, 50);
    };

    window.gsShowPopup = function () {
      window.kbShowLeadPopup({
        ignoreCustomilyIntercept: true,
        source: "cart_help"
      });
    };

    document.getElementById("gsPopupClose").onclick = function () {
      localStorage.setItem(LS_HIDE_HELP, "1");
      sendEvent("lead_popup_closed", getLeadPopupEventData("close_button", { source: "close_button" }));
      hide();
    };

    document.getElementById("gsSkipPopup").onclick = function () {
      localStorage.setItem(LS_SKIP_UNTIL, String(Date.now() + POPUP_SKIP_MS));
      sendEvent("lead_popup_skip", getLeadPopupEventData("skip", { source: "skip_button" }));
      hide();
      continuePendingCustomilyClick();
    };

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        sendEvent("lead_popup_closed", getLeadPopupEventData("overlay_click", { source: "overlay_click" }));
        hide();
      }
    });

    var quickLinks = [
      { selector: ".gsWhatsApp", event: "lead_popup_quick_whatsapp_click", source: "whatsapp" },
      { selector: ".gsViber", event: "lead_popup_quick_viber_click", source: "viber" },
      { selector: ".gsCall", event: "lead_popup_quick_call_click", source: "call" }
    ];

    quickLinks.forEach(function (item) {
      var link = overlay.querySelector(item.selector);
      if (!link) return;
      link.addEventListener("click", function () {
        sendEvent(item.event, getLeadPopupEventData("quick_contact", {
          source: item.source
        }));
      });
    });

    document.getElementById("gsPopupSubmit").onclick = function () {
      var data = {
        fname: document.getElementById("gsFirstName").value.trim(),
        lname: document.getElementById("gsLastName").value.trim(),
        email: document.getElementById("gsEmail").value.trim(),
        phone: normalizePhone(document.getElementById("gsPhone").value.trim()),
        extra: { source: "custom_popup" }
      };

      if (!data.fname || !data.lname || !isValidEmail(data.email) || !data.phone) {
        alert("Molimo proverite ime, prezime, email i telefon.");
        return;
      }

      sendEvent("lead_popup_submit", getLeadPopupEventData("submit", {
        source: "submit_button"
      }));

      collectLead(data).then(function () {
        hide();
        continuePendingCustomilyClick();
      });
    };
  }

  function bindEcomSend(root) {
    root = root || document;
    var buttons = root.querySelectorAll(".ecomsend__Button, .ecomsend button, [class*='ecomsend'] button, [id^='ecomsend-submit-button'] [role='button']");
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.__kbLeadBound) return;
      btn.__kbLeadBound = true;
      btn.addEventListener("click", function () {
        setTimeout(function () {
          var scope = findScopeWithInputs(btn);
          var data = readFields(scope);
          data.extra = { source: "ecomsend_button", label: (btn.innerText || "").trim() };
          log("KB EcomSend fields", data);
          if (data.email || data.phone) collectLead(data);
        }, 300);
      }, true);
    });

    var forms = root.querySelectorAll(".ecomsend form, form[class*='ecomsend']");
    Array.prototype.forEach.call(forms, function (form) {
      if (form.__kbLeadBound) return;
      form.__kbLeadBound = true;
      form.addEventListener("submit", function () {
        setTimeout(function () {
          var data = readFields(form);
          data.extra = { source: "ecomsend_submit" };
          if (data.email || data.phone) collectLead(data);
        }, 300);
      }, true);
    });
  }

  function setupPhoneCapture() {
    var timer = null;
    document.addEventListener("input", function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains("react-international-phone-input")) return;

      var phone = normalizePhone(el.value || el.getAttribute("value") || "");
      window.__kbLastPhone = phone;
      var scope = findScopeWithInputs(el);
      var hasEmailField = !!scope.querySelector("#email, input[type='email']");

      if (!hasEmailField && phone) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          identifyByPhone(phone, "customily_phone");
        }, 900);
      }
    }, true);
  }

  function setupCartTracking() {
    var lastCount = 0;

    function updateCartCount() {
      return fetchCart().then(function (cart) {
        lastCount = cart.items && Array.isArray(cart.items) ? cart.items.length : 0;
        return cart;
      });
    }

    function sendCartEvent(type) {
      setTimeout(function () {
        fetchCart().then(function (cart) {
          ensureLeadFromCart(cart);
          sendEvent(type, {
            total_price: cart.total_price || 0,
            item_count: cart.items && Array.isArray(cart.items) ? cart.items.length : 0,
            items: cart.items || []
          }, { cart: cart });
          updateCartCount();
        });
      }, 250);
    }

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : input && input.url;
      var result = originalFetch.apply(this, arguments);
      if (url && (url.indexOf("/cart/add") !== -1 || url.indexOf("/cart/update") !== -1 || url.indexOf("/cart/change") !== -1)) {
        result.finally(function () {
          sendCartEvent(url.indexOf("/cart/add") !== -1 ? "add_to_cart" : "update_cart");
        });
      }
      return result;
    };

    document.addEventListener("click", function (e) {
      if (e.target.closest("form[action*='/cart/add'], button[name='add'], button.add-to-cart")) {
        sendCartEvent("add_to_cart");
      }
    }, true);

    updateCartCount().then(function (cart) {
      ensureLeadFromCart(cart);
      sendEvent("cart_snapshot", {
        total_price: cart.total_price || 0,
        item_count: cart.items && Array.isArray(cart.items) ? cart.items.length : 0,
        items: cart.items || []
      }, { cart: cart });
    });
  }

  function parseMoneyText(text) {
    var value = String(text || "")
      .replace(/\s/g, "")
      .replace(/[^\d,.-]/g, "");
    var lastComma = value.lastIndexOf(",");
    var lastDot = value.lastIndexOf(".");
    var decimalSeparator = "";

    if (lastComma > -1 && lastDot > -1) {
      decimalSeparator = lastComma > lastDot ? "," : ".";
    } else if (lastComma > -1) {
      decimalSeparator = value.length - lastComma - 1 === 3 ? "" : ",";
    } else if (lastDot > -1) {
      decimalSeparator = value.length - lastDot - 1 === 3 ? "" : ".";
    }

    if (decimalSeparator) {
      var thousandsSeparator = decimalSeparator === "," ? "." : ",";
      value = value.split(thousandsSeparator).join("").replace(decimalSeparator, ".");
    } else {
      value = value.replace(/[,.]/g, "");
    }

    var parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  function getCartDrawerTotal() {
    var totalEl = document.querySelector("#CartDrawer .totals__total-value, .totals__total-value");
    return totalEl ? parseMoneyText(totalEl.textContent) : 0;
  }

  function getStoredRecommendedProducts() {
    var products = safeJsonParse(localStorage.getItem(LS_RECOMMENDED_PRODUCTS), []);
    return Array.isArray(products) ? products : [];
  }

  function absoluteShopUrl(path) {
    if (!path) return "";
    if (path.indexOf("//") === 0) return "https:" + path;
    if (path.indexOf("http") === 0) return path;
    return window.location.origin + path;
  }

  function shopRedirectPath(url) {
    var absoluteUrl = absoluteShopUrl(url);
    if (!absoluteUrl) return "/cart";

    try {
      var parsed = new URL(absoluteUrl, window.location.origin);
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return "/cart";
    }
  }

  function formatThreshold(value) {
    var amount = parseInt(value || 0, 10);
    if (isNaN(amount) || amount <= 0) return "";
    return amount.toLocaleString("sr-RS") + " RSD";
  }

  function rememberCouponNotice(options, redirect) {
    if (!window.sessionStorage) return;

    try {
      sessionStorage.setItem(SS_COUPON_NOTICE, JSON.stringify({
        code: CART_DISCOUNT_CODE,
        threshold: options.threshold || 0,
        source: options.shownEvent || "",
        redirect: redirect || "/cart",
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function injectCouponNoticeStyles() {
    if (document.getElementById("kbCouponNoticeStyles")) return;

    var style = document.createElement("style");
    style.id = "kbCouponNoticeStyles";
    style.textContent = [
      ".kbCouponNotice{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:2147482996;width:min(560px,calc(100vw - 28px));box-sizing:border-box;background:#111;color:#fff;border-radius:12px;box-shadow:0 18px 46px rgba(0,0,0,.26);padding:14px 14px 14px 16px;font-family:inherit;display:flex;align-items:center;gap:12px}",
      ".kbCouponNoticeText{margin:0;flex:1;font-size:15px;line-height:1.38;color:#fff}",
      ".kbCouponNoticeText b{color:#fff}",
      ".kbCouponNoticeCart{flex:0 0 auto;border:0;border-radius:999px;background:#E88A2D;color:#fff;text-decoration:none;font-weight:700;font-size:13px;line-height:1;padding:11px 14px;white-space:nowrap}",
      ".kbCouponNoticeClose{flex:0 0 auto;width:34px;height:34px;border:0;border-radius:999px;background:rgba(255,255,255,.12);color:#fff;font-size:24px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}",
      "@media(max-width:520px){.kbCouponNotice{left:14px;right:14px;bottom:12px;transform:none;width:auto;align-items:stretch;display:grid;grid-template-columns:1fr 34px;gap:10px}.kbCouponNoticeCart{grid-column:1 / 3;text-align:center;padding-top:12px;padding-bottom:12px}.kbCouponNoticeText{font-size:14px}}"
    ].join("");
    document.head.appendChild(style);
  }

  function showPendingCouponNotice() {
    if (!window.sessionStorage) return;

    var notice = null;
    try {
      notice = safeJsonParse(sessionStorage.getItem(SS_COUPON_NOTICE), null);
      sessionStorage.removeItem(SS_COUPON_NOTICE);
    } catch (e) {
      return;
    }

    if (!notice || !notice.code) return;
    if (notice.ts && Date.now() - parseInt(notice.ts, 10) > 10 * 60 * 1000) return;

    injectCouponNoticeStyles();

    var threshold = formatThreshold(notice.threshold);
    var isFreeDelivery = notice.source === "free_delivery_popup_shown";
    var text = "Kod " + notice.code + " je aktiviran.";
    if (threshold && isFreeDelivery) {
      text += " Važi za besplatnu dostavu preko " + threshold + ".";
    } else if (threshold) {
      text += " Važi za korpe preko " + threshold + ".";
    }

    var bar = document.createElement("div");
    bar.className = "kbCouponNotice";
    bar.setAttribute("role", "status");

    var copy = document.createElement("p");
    copy.className = "kbCouponNoticeText";
    copy.innerHTML = text.replace(notice.code, "<b>" + notice.code + "</b>");

    var cartLink = document.createElement("a");
    cartLink.className = "kbCouponNoticeCart";
    cartLink.href = "/cart";
    cartLink.textContent = "IDI U KORPU";

    var close = document.createElement("button");
    close.type = "button";
    close.className = "kbCouponNoticeClose";
    close.setAttribute("aria-label", "Zatvori");
    close.innerHTML = "&times;";

    function removeNotice() {
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    }

    close.addEventListener("click", removeNotice);
    bar.appendChild(copy);
    bar.appendChild(cartLink);
    bar.appendChild(close);
    document.body.appendChild(bar);

    setTimeout(removeNotice, 12000);
  }

  function injectFloatingActionsStyles() {
    if (document.getElementById("kbFloatingActionsStyles")) return;

    var style = document.createElement("style");
    style.id = "kbFloatingActionsStyles";
    style.textContent = [
      ".kbFloatingActions{position:fixed;right:18px;bottom:126px;z-index:2147482988;font-family:inherit;display:flex;flex-direction:column;align-items:flex-end;gap:10px}",
      ".kbFloatingMain{display:flex;flex-direction:column;gap:10px}",
      ".kbFloatingBtn{width:56px;height:56px;border:0;border-radius:999px;background:#111;color:#fff;box-shadow:0 12px 34px rgba(0,0,0,.26);display:flex;align-items:center;justify-content:center;text-decoration:none;cursor:pointer;position:relative;font-size:20px;line-height:1;transition:transform .16s,opacity .16s,background .16s,box-shadow .16s}",
      ".kbFloatingBtn:hover{transform:translateY(-1px);background:#222;color:#fff;box-shadow:0 14px 38px rgba(0,0,0,.3)}",
      ".kbFloatingBtn:focus-visible{outline:3px solid rgba(232,138,45,.35);outline-offset:3px}",
      ".kbFloatingBtnHelp{background:#E88A2D}",
      ".kbFloatingBtnHelp:hover{background:#d97a1f}",
      ".kbFloatingCartCount{position:absolute;right:-4px;top:-4px;min-width:20px;height:20px;border-radius:999px;background:#E88A2D;color:#fff;border:2px solid #fff;font-size:11px;font-weight:700;line-height:16px;display:flex;align-items:center;justify-content:center;padding:0 5px;box-sizing:border-box}",
      ".kbFloatingCartCount.is-empty{display:none}",
      ".kbFloatingPanel{position:absolute;right:0;bottom:132px;width:min(260px,calc(100vw - 32px));background:#fff;color:#111;border:1px solid rgba(0,0,0,.1);border-radius:12px;box-shadow:0 18px 56px rgba(0,0,0,.24);padding:8px;box-sizing:border-box;opacity:0;visibility:hidden;transform:translateY(8px);pointer-events:none;transition:opacity .16s,transform .16s,visibility .16s}",
      ".kbFloatingPanel.is-open{opacity:1;visibility:visible;transform:translateY(0);pointer-events:auto}",
      ".kbFloatingLink{min-height:42px;border-radius:8px;display:flex;align-items:center;gap:10px;text-decoration:none;color:#111;font-size:14px;line-height:1.2;padding:10px 12px;box-sizing:border-box}",
      ".kbFloatingLink:hover{background:#f5f5f5;color:#111}",
      ".kbFloatingLink i{width:18px;text-align:center;color:#E88A2D;font-size:16px}",
      "@media(max-width:520px){.kbFloatingActions{right:12px;bottom:156px}.kbFloatingMain{gap:10px}.kbFloatingBtn{width:56px;height:56px;font-size:20px}.kbFloatingPanel{bottom:132px;right:0}}"
    ].join("");
    document.head.appendChild(style);
  }

  function openFloatingCart(ev) {
    if (ev) ev.preventDefault();

    var drawer = document.querySelector("cart-drawer") || document.getElementById("CartDrawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return;
    }

    var cartIcon = document.querySelector("#cart-icon-bubble, a[href='/cart']");
    if (cartIcon && cartIcon.getAttribute("aria-controls")) {
      cartIcon.click();
      return;
    }

    window.location.href = "/cart";
  }

  function trackFloatingAction(action) {
    sendEvent("floating_action_click", {
      action: action,
      url: window.location.href,
      pathname: window.location.pathname
    });
  }

  function setupFloatingActions() {
    if (window.__kbFloatingActionsInit) return;
    window.__kbFloatingActionsInit = true;

    var legacy = document.querySelector(".floating-buttons-container:not([data-kb-floating-actions])");
    if (legacy && legacy.parentNode) legacy.parentNode.removeChild(legacy);

    injectFloatingActionsStyles();

    var root = document.createElement("div");
    root.className = "kbFloatingActions";
    root.setAttribute("data-kb-floating-actions", "1");

    var panel = document.createElement("div");
    panel.id = "kbFloatingHelpPanel";
    panel.className = "kbFloatingPanel";
    panel.setAttribute("role", "menu");
    panel.setAttribute("aria-hidden", "true");

    var actions = [
      { label: "Poziv", href: "tel:+381658416212", icon: "fas fa-phone", action: "call" },
      { label: "SMS", href: "sms:+381658416212", icon: "fas fa-sms", action: "sms" },
      { label: "Viber", href: "viber://chat?number=%2B381658416212", icon: "fab fa-viber", action: "viber" },
      { label: "WhatsApp", href: "https://wa.me/381658416212", icon: "fab fa-whatsapp", action: "whatsapp", target: "_blank" },
      { label: "Pomoć dizajnera", href: "/pages/pomoc-dizajnera-za-kucni-broj", icon: "fas fa-paint-brush", action: "designer_help" },
      { label: "Cenovnik", href: "/pages/cenovnik", icon: "fas fa-dollar-sign", action: "price_list" }
    ];

    actions.forEach(function (item) {
      var link = document.createElement("a");
      link.className = "kbFloatingLink";
      link.href = item.href;
      link.setAttribute("role", "menuitem");
      if (item.target) {
        link.target = item.target;
        link.rel = "noopener";
      }
      link.innerHTML = "<i class='" + item.icon + "' aria-hidden='true'></i><span>" + item.label + "</span>";
      link.addEventListener("click", function () {
        trackFloatingAction(item.action);
        setPanel(false);
      });
      panel.appendChild(link);
    });

    var main = document.createElement("div");
    main.className = "kbFloatingMain";

    var helpButton = document.createElement("button");
    helpButton.type = "button";
    helpButton.className = "kbFloatingBtn kbFloatingBtnHelp";
    helpButton.setAttribute("aria-label", "Pomoc");
    helpButton.setAttribute("aria-controls", panel.id);
    helpButton.setAttribute("aria-expanded", "false");
    helpButton.innerHTML = "<i class='fas fa-headset' aria-hidden='true'></i>";

    var cartButton = document.createElement("a");
    cartButton.href = "/cart";
    cartButton.className = "kbFloatingBtn kbFloatingBtnCart";
    cartButton.setAttribute("aria-label", "Korpa");
    cartButton.innerHTML = "<i class='fas fa-shopping-cart' aria-hidden='true'></i><span id='kbFloatingCartCount' class='kbFloatingCartCount is-empty'>0</span>";

    function setPanel(open) {
      panel.classList.toggle("is-open", open);
      panel.setAttribute("aria-hidden", open ? "false" : "true");
      helpButton.setAttribute("aria-expanded", open ? "true" : "false");
    }

    function refreshCartCount() {
      fetchCart().then(function (cart) {
        var badge = document.getElementById("kbFloatingCartCount");
        if (!badge) return;
        var count = parseInt(cart.item_count || 0, 10);
        badge.textContent = String(count);
        badge.classList.toggle("is-empty", count <= 0);
      });
    }

    helpButton.addEventListener("click", function () {
      trackFloatingAction("open_help_panel");
      setPanel(!panel.classList.contains("is-open"));
    });

    cartButton.addEventListener("click", function (ev) {
      trackFloatingAction("cart");
      openFloatingCart(ev);
    });

    document.addEventListener("click", function (ev) {
      if (!panel.classList.contains("is-open")) return;
      if (root.contains(ev.target)) return;
      setPanel(false);
    });

    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape") setPanel(false);
    });

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") refreshCartCount();
    });

    if (!window.__kbFloatingCartFetchPatched) {
      var originalFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : input && input.url;
        var result = originalFetch.apply(this, arguments);
        if (url && /\/cart\/(add|change|update)\.js?/.test(url)) {
          result.finally(function () { setTimeout(refreshCartCount, 180); });
        }
        return result;
      };
      window.__kbFloatingCartFetchPatched = true;
    }

    window.addEventListener("cart:updated", refreshCartCount);
    window.openFloatingCart = openFloatingCart;

    main.appendChild(helpButton);
    main.appendChild(cartButton);
    root.appendChild(panel);
    root.appendChild(main);
    document.body.appendChild(root);
    refreshCartCount();
  }

  function formatPrice(value) {
    var cents = parseInt(value || 0, 10);
    if (isNaN(cents) || cents <= 0) return "";
    return Math.round(cents / 100).toLocaleString("sr-RS") + " RSD";
  }

  function saveRecommendedProducts(products) {
    var seen = {};
    var unique = [];
    products.forEach(function (product) {
      if (!product || !product.name || !product.link) return;
      var key = product.name + "|" + product.link;
      if (seen[key]) return;
      seen[key] = true;
      unique.push(product);
    });
    localStorage.setItem(LS_RECOMMENDED_PRODUCTS, JSON.stringify(unique));
  }

  function addRecommendedProducts(products) {
    saveRecommendedProducts(getStoredRecommendedProducts().concat(products || []));
  }

  function getCurrentProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function getCurrentProductId() {
    if (config.productId) return Promise.resolve(config.productId);
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return Promise.resolve(window.ShopifyAnalytics.meta.product.id);
    }

    var handle = getCurrentProductHandle();
    if (!handle) return Promise.resolve(null);

    return fetch("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (r) { return r.json(); })
      .then(function (product) { return product && product.id ? product.id : null; })
      .catch(function () { return null; });
  }

  function normalizeShopifyProduct(product) {
    if (!product) return null;
    var image = product.featured_image || (product.images && product.images[0]) || "";
    var link = product.url || (product.handle ? "/products/" + product.handle : "");
    var name = product.title || product.name || "";
    if (!name || !link) return null;

    return {
      image: absoluteShopUrl(image),
      link: absoluteShopUrl(link),
      name: name,
      price: product.price ? formatPrice(product.price) : (product.price_min ? formatPrice(product.price_min) : "")
    };
  }

  function collectConfiguredFallbackProducts() {
    if (!Array.isArray(config.cartDiscountFallbackProducts)) return [];
    return config.cartDiscountFallbackProducts.map(function (product) {
      if (!product || !product.name || !product.link) return null;
      return {
        image: absoluteShopUrl(product.image || ""),
        link: absoluteShopUrl(product.link),
        name: product.name,
        price: product.price || ""
      };
    }).filter(Boolean);
  }

  function collectShopifyRecommendationProducts() {
    return getCurrentProductId().then(function (productId) {
      if (!productId) return [];

      var url = "/recommendations/products.json?product_id=" + encodeURIComponent(productId) +
        "&limit=" + encodeURIComponent(CART_RECOMMENDATION_LIMIT) +
        "&intent=related";

      return fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data && Array.isArray(data.products) ? data.products : [];
          return products.map(normalizeShopifyProduct).filter(Boolean);
        })
        .catch(function () { return []; });
    });
  }

  function collectRecommendedProducts() {
    var products = getStoredRecommendedProducts();
    var nodes = document.querySelectorAll("[data-essential-upsell-funnel-content-offer-type='CROSS_SELL'] [data-essential-upsell-element='product']");

    Array.prototype.forEach.call(nodes, function (node) {
      var image = node.querySelector("img[data-essential-upsell-element='image']");
      var title = node.querySelector("a[data-essential-upsell-element='title']");
      var price = node.querySelector("div[data-essential-upsell-element='price']");
      if (!image || !title) return;

      var imageSrc = image.getAttribute("src") || "";
      var href = title.getAttribute("href") || "";
      products.push({
        image: imageSrc.indexOf("//") === 0 ? "https:" + imageSrc : imageSrc,
        link: href.indexOf("http") === 0 ? href : "https://www.kucnibrojevi.com" + href,
        name: title.textContent.trim(),
        price: price ? price.textContent.trim() : ""
      });
    });

    saveRecommendedProducts(products);

    if (products.length) return Promise.resolve(products);

    var configuredFallback = collectConfiguredFallbackProducts();
    if (configuredFallback.length) {
      addRecommendedProducts(configuredFallback);
      return Promise.resolve(configuredFallback);
    }

    return collectShopifyRecommendationProducts().then(function (shopifyProducts) {
      addRecommendedProducts(shopifyProducts);
      return shopifyProducts;
    });
  }

  function getProductPriceValue(product) {
    return parseMoneyText(product && product.price);
  }

  function pickSuggestedProduct(minPrice) {
    var products = getStoredRecommendedProducts();
    var cartItems = Array.prototype.slice.call(document.querySelectorAll("#CartDrawer-CartItems .cart-item__name"))
      .map(function (item) { return item.textContent.trim(); });
    var available = products.filter(function (product) {
      if (cartItems.indexOf(product.name) !== -1) return false;
      if (minPrice && getProductPriceValue(product) < minPrice) return false;
      return true;
    });

    if (!available.length) return null;
    return available[Math.floor(Math.random() * available.length)];
  }

  function getFreeDeliverySuggestedProduct(cartTotal) {
    var missingAmount = Math.max(0, FREE_SHIPPING_THRESHOLD - cartTotal);
    if (!missingAmount) return null;
    return pickSuggestedProduct(missingAmount);
  }

  function isFreeDeliveryPopupApplicable(cartTotal) {
    if (!FREE_DELIVERY_POPUP_ENABLED) return false;
    if (cartTotal <= 0) return false;
    if (cartTotal >= FREE_SHIPPING_THRESHOLD) return false;
    if (cartTotal < MIN_CART_TOTAL_TO_SHOW_FREE_DELIVERY) return false;
    return !!getFreeDeliverySuggestedProduct(cartTotal);
  }

  function shouldShowFreeDeliveryPopup(cartTotal) {
    if (!canShowAnyPopup()) return false;
    if (isCooldownActive(LS_FREE_DELIVERY_POPUP_CLOSED_UNTIL)) return false;
    return isFreeDeliveryPopupApplicable(cartTotal);
  }

  function shouldShowRecommendedProductPopup(cartTotal) {
    if (config.cartDiscountPopup === false) return false;
    if (!canShowAnyPopup()) return false;
    if (isCooldownActive(LS_CART_POPUP_CLOSED_UNTIL)) return false;
    if (cartTotal <= 0 || cartTotal >= CART_DISCOUNT_THRESHOLD) return false;
    if (cartTotal < MIN_CART_TOTAL_TO_SHOW_CART_DISCOUNT) return false;
    if (isFreeDeliveryPopupApplicable(cartTotal)) return false;
    return true;
  }

  function closeCartPopup() {
    var overlay = document.getElementById("cartDiscountOverlay");
    var popup = document.getElementById("cartDiscountPopup");
    if (overlay) overlay.remove();
    if (popup) popup.remove();
    localStorage.setItem(LS_CART_POPUP_CLOSED_UNTIL, String(Date.now() + CART_POPUP_COOLDOWN_MS));
    releasePopupLock();
  }

  function closeFreeDeliveryPopup() {
    var overlay = document.getElementById("freeDeliveryOverlay");
    var popup = document.getElementById("freeDeliveryPopup");
    if (overlay) overlay.remove();
    if (popup) popup.remove();
    localStorage.setItem(LS_FREE_DELIVERY_POPUP_CLOSED_UNTIL, String(Date.now() + FREE_DELIVERY_POPUP_COOLDOWN_MS));
    releasePopupLock();
  }

  function closeCartDiscountPopup() {
    closeCartPopup();
  }

  function removeLegacyCartPopup() {
    var popups = Array.prototype.slice.call(document.querySelectorAll("#cartDiscountPopup"));
    popups.forEach(function (popup) {
      var text = popup.textContent || "";
      if (text.indexOf(CART_DISCOUNT_CODE) !== -1) return;
      if (text.indexOf("Poklanjamo ti kupon") === -1 && text.indexOf("SSTIPO") === -1) return;

      var overlay = document.getElementById("cartDiscountOverlay");
      if (overlay) overlay.remove();
      popup.remove();
      releasePopupLock();
    });
  }

  function suppressLegacyCartPopup() {
    removeLegacyCartPopup();
  }

  function injectCartPopupStyles() {
    if (document.getElementById("kbCartPopupStyles")) return;

    var style = document.createElement("style");
    style.id = "kbCartPopupStyles";
    style.textContent = [
      ".kbCartPopupOverlay{position:fixed;inset:0;z-index:2147482998;background:rgba(0,0,0,.5);padding:16px;box-sizing:border-box}",
      ".kbCartPopup{width:min(500px,calc(100vw - 32px));max-height:calc(100vh - 32px);overflow-y:auto;box-sizing:border-box;background:#fff;color:#111;border:1px solid #ccc;box-shadow:0 14px 40px rgba(0,0,0,.22);position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2147482999;padding:24px 20px 20px}",
      ".kbCartPopupClose{cursor:pointer;position:absolute;right:8px;top:6px;border:0;background:transparent;font-size:30px;line-height:1;width:40px;height:40px;display:flex;align-items:center;justify-content:center;color:#111}",
      ".kbCartPopupTitle{margin:0 34px 14px;text-align:center;font-size:24px;line-height:1.22;font-weight:500;letter-spacing:0}",
      ".kbCartPopupText{margin:0 auto 16px;text-align:center;line-height:1.45;color:#000;font-size:16px;max-width:430px}",
      ".kbCartPopupProduct{display:flex;align-items:center;gap:12px;margin:26px 30px 32px;min-width:0}",
      ".kbCartPopupProductImage{width:80px;height:80px;max-width:80px;max-height:80px;object-fit:contain;display:block;flex:0 0 auto}",
      ".kbCartPopupProductCopy{min-width:0;flex:1}",
      ".kbCartPopupProductName{margin:0 0 6px;color:#000;font-size:15px;line-height:1.35;overflow-wrap:anywhere}",
      ".kbCartPopupProductPrice{margin:0;color:#E88A2D;font-size:15px;line-height:1.35}",
      ".kbCartPopupButton{width:100%;min-height:50px;border:none;border-radius:25px;background:#E88A2D;color:#fff;display:inline-block;text-align:center;padding:13px 24px;font-size:16px;cursor:pointer;line-height:1.25;font-weight:500;margin-bottom:16px}",
      ".kbCartPopupCode{margin:0 0 18px;text-align:center;color:#666;font-size:15px;line-height:1.35}",
      ".kbCartPopupUrgency{margin:0;text-align:center;font-weight:700;color:#555;font-size:16px;line-height:1.35;letter-spacing:.02em}",
      "@media(max-width:420px){.kbCartPopup{padding:22px 16px 18px}.kbCartPopupTitle{font-size:22px;margin-left:30px;margin-right:30px}.kbCartPopupText{font-size:15px}.kbCartPopupProduct{margin:20px 0 26px;gap:10px}.kbCartPopupProductImage{width:74px;height:74px}.kbCartPopupButton{font-size:15px;padding-left:16px;padding-right:16px}.kbCartPopupCode,.kbCartPopupUrgency{font-size:14px}}",
      "@media(max-width:340px){.kbCartPopup{width:calc(100vw - 20px);padding-left:12px;padding-right:12px}.kbCartPopupTitle{font-size:20px}.kbCartPopupProductImage{width:64px;height:64px}.kbCartPopupProductName,.kbCartPopupProductPrice{font-size:14px}}"
    ].join("");
    document.head.appendChild(style);
  }

  function setupLegacyPopupBlocker() {
    window.triggerCartDiscountPopup = suppressLegacyCartPopup;
    removeLegacyCartPopup();

    var runs = 0;
    var timer = setInterval(function () {
      window.triggerCartDiscountPopup = suppressLegacyCartPopup;
      removeLegacyCartPopup();
      runs += 1;
      if (runs >= 60) clearInterval(timer);
    }, 1000);
  }

  function appendSuggestedProduct(popup, suggestedProduct) {
    if (!suggestedProduct) return;

    var productRow = document.createElement("div");
    productRow.className = "kbCartPopupProduct";

    var imageLink = document.createElement("a");
    imageLink.href = suggestedProduct.link;

    var image = document.createElement("img");
    image.src = suggestedProduct.image;
    image.alt = suggestedProduct.name;
    image.className = "kbCartPopupProductImage";
    imageLink.appendChild(image);

    var copy = document.createElement("div");
    copy.className = "kbCartPopupProductCopy";

    var nameLink = document.createElement("a");
    nameLink.href = suggestedProduct.link;
    nameLink.style.textDecoration = "none";

    var name = document.createElement("p");
    name.textContent = suggestedProduct.name;
    name.className = "kbCartPopupProductName";

    var price = document.createElement("p");
    price.textContent = suggestedProduct.price;
    price.className = "kbCartPopupProductPrice";

    nameLink.appendChild(name);
    copy.appendChild(nameLink);
    copy.appendChild(price);
    productRow.appendChild(imageLink);
    productRow.appendChild(copy);
    popup.appendChild(productRow);
  }

  function showProductPopup(options) {
    if (document.getElementById(options.popupId)) return;
    if (!canShowAnyPopup()) return;

    injectCartPopupStyles();
    markPopupShown();

    var discountRedirect = "/cart";
    if (options.suggestedProduct && options.suggestedProduct.link) {
      discountRedirect = shopRedirectPath(options.suggestedProduct.link);
    }

    var overlay = document.createElement("div");
    overlay.id = options.overlayId;
    overlay.className = "kbCartPopupOverlay";
    overlay.addEventListener("click", options.close);

    var popup = document.createElement("div");
    popup.id = options.popupId;
    popup.className = "kbCartPopup";

    var closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", "Zatvori");
    closeButton.innerHTML = "&times;";
    closeButton.className = "kbCartPopupClose";
    closeButton.addEventListener("click", options.close);

    var heading = document.createElement("h2");
    heading.textContent = options.heading;
    heading.className = "kbCartPopupTitle";

    var subheading = document.createElement("p");
    subheading.innerHTML = options.bodyHtml;
    subheading.className = "kbCartPopupText";

    popup.appendChild(closeButton);
    popup.appendChild(heading);
    popup.appendChild(subheading);
    appendSuggestedProduct(popup, options.suggestedProduct);

    var button = document.createElement("button");
    button.type = "button";
    button.textContent = options.suggestedProduct ? "POGLEDAJ PROIZVOD I PREUZMI KUPON" : "PREUZMI KUPON";
    button.className = "kbCartPopupButton";
    button.addEventListener("click", function () {
      rememberCouponNotice(options, discountRedirect);
      sendEvent(options.clickEvent, {
        code: CART_DISCOUNT_CODE,
        cart_total: options.cartTotal,
        threshold: options.threshold,
        missing_amount: options.missingAmount || 0,
        suggested_product: options.suggestedProduct || null,
        redirect: discountRedirect
      });
      window.location.href = "https://www.kucnibrojevi.com/discount/" + encodeURIComponent(CART_DISCOUNT_CODE) + "?redirect=" + encodeURIComponent(discountRedirect);
    });

    var additionalMessage = document.createElement("p");
    additionalMessage.innerHTML = "Ili ukucaj kupon kod: <b>" + CART_DISCOUNT_CODE + "</b>";
    additionalMessage.className = "kbCartPopupCode";

    var message = document.createElement("p");
    message.textContent = "PONUDA TRAJE JOŠ 30 MINUTA!";
    message.className = "kbCartPopupUrgency";

    popup.appendChild(button);
    popup.appendChild(additionalMessage);
    popup.appendChild(message);
    document.body.appendChild(overlay);
    document.body.appendChild(popup);

    sendEvent(options.shownEvent, {
      code: CART_DISCOUNT_CODE,
      cart_total: options.cartTotal,
      threshold: options.threshold,
      missing_amount: options.missingAmount || 0,
      suggested_product: options.suggestedProduct || null,
      redirect: discountRedirect
    });
  }

  function showFreeDeliveryPopup(cartTotal) {
    var missingAmount = Math.max(0, Math.ceil(FREE_SHIPPING_THRESHOLD - cartTotal));
    var suggestedProduct = getFreeDeliverySuggestedProduct(cartTotal);
    if (!suggestedProduct) return;

    showProductPopup({
      overlayId: "freeDeliveryOverlay",
      popupId: "freeDeliveryPopup",
      close: closeFreeDeliveryPopup,
      heading: "Hej! Poklanjamo ti kupon za besplatnu dostavu!",
      bodyHtml: "Bitno je da u korpi imaš proizvode u vrednosti od <b>minimum " + FREE_SHIPPING_THRESHOLD.toLocaleString("sr-RS") + " RSD</b>.<br>Fali ti još <b>" + missingAmount.toLocaleString("sr-RS") + " RSD</b>, evo proizvoda koji pokriva razliku:",
      suggestedProduct: suggestedProduct,
      cartTotal: cartTotal,
      threshold: FREE_SHIPPING_THRESHOLD,
      missingAmount: missingAmount,
      shownEvent: "free_delivery_popup_shown",
      clickEvent: "free_delivery_coupon_click"
    });
  }

  function showCartDiscountPopup(cartTotal) {
    var total = typeof cartTotal === "number" ? cartTotal : getCartDrawerTotal();
    var missingAmount = Math.max(0, Math.ceil(CART_DISCOUNT_THRESHOLD - total));
    var suggestedProduct = pickSuggestedProduct();

    showProductPopup({
      overlayId: "cartDiscountOverlay",
      popupId: "cartDiscountPopup",
      close: closeCartPopup,
      heading: "Besplatna dostava uz kod " + CART_DISCOUNT_CODE,
      bodyHtml: "Kupon važi za korpe preko <b>" + CART_DISCOUNT_THRESHOLD.toLocaleString("sr-RS") + " RSD</b>.<br>Fali ti još <b>" + missingAmount.toLocaleString("sr-RS") + " RSD</b>" + (suggestedProduct ? ", evo jedne ideje:" : "."),
      suggestedProduct: suggestedProduct,
      cartTotal: total,
      threshold: CART_DISCOUNT_THRESHOLD,
      missingAmount: missingAmount,
      shownEvent: "cart_discount_popup_shown",
      clickEvent: "cart_discount_coupon_click"
    });
  }

  function setupCartDiscountPopup() {
    if (config.cartDiscountPopup === false) return;

    if (window.location.pathname.indexOf("/products/") !== -1) {
      setTimeout(collectRecommendedProducts, 4000);
    }

    var cartDrawer = document.querySelector("cart-drawer.drawer");
    if (!cartDrawer) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== "attributes" || mutation.attributeName !== "class") return;
        if (!mutation.target.classList.contains("active")) return;

        setTimeout(function () {
          collectRecommendedProducts().finally(function () {
            var total = getCartDrawerTotal();
            if (shouldShowFreeDeliveryPopup(total)) {
              showFreeDeliveryPopup(total);
            } else if (shouldShowRecommendedProductPopup(total)) {
              showCartDiscountPopup(total);
            }
          });
        }, 3000);
      });
    });

    observer.observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
    log("KB cart discount popup observer started");
  }

  function setupAutoEvents() {
    initLeadOnce().finally(function () {
      sendEvent("page_view", { title: document.title, url: window.location.href });

      if (window.location.pathname.indexOf("/products/") !== -1) {
        sendEvent("view_product", {
          title: (document.querySelector("h1") || {}).innerText || "",
          url: window.location.href
        });
      }

      if (window.location.pathname.indexOf("/collections/") !== -1) {
        sendEvent("view_category", {
          category_title: (window.GS_COLLECTION && window.GS_COLLECTION.title) || document.title,
          category_handle: (window.GS_COLLECTION && window.GS_COLLECTION.handle) || "",
          category_id: (window.GS_COLLECTION && window.GS_COLLECTION.id) || null,
          url: window.location.href
        });
      }
    });
  }

  function setupObservers() {
    bindEcomSend(document);
    var observer = new MutationObserver(function (mutations) {
      bindEcomSend(document);
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) bindEcomSend(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function setupPopupTriggers() {
    document.addEventListener("click", function (e) {
      var helpBtn = e.target.closest("[data-kb-lead-help], .gs-help-btn");
      if (!helpBtn) return;

      e.preventDefault();
      if (typeof window.gsShowPopup === "function") {
        window.gsShowPopup();
      }
    }, true);

    document.addEventListener("click", function (e) {
      var customilyBtn = e.target.closest("#customily-personalize-button");
      if (!customilyBtn) return;
      if (!shouldShowLeadPopup()) return;
      if (typeof window.kbShowLeadPopup !== "function") return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.__kbPendingCustomilyClick = true;
      window.kbShowLeadPopup();
    }, true);
  }

  function boot() {
    window.gsLeadId = leadId;
    window.gsAnonId = anonId;
    window.gsSendLeadBaseData = function (extra) {
      extra = extra || {};
      if (extra.source === "custom_popup") {
        return collectLead({
          fname: extra.fname || "",
          lname: extra.lname || "",
          email: extra.email || "",
          phone: extra.phone || "",
          extra: extra
        });
      }

      var data = readFields(extra.scope || document);
      data.extra = extra;
      if (data.email || data.phone) return collectLead(data);
      return Promise.resolve(null);
    };
    window.ensureLeadFromCart = ensureLeadFromCart;
    window.sendEvent = sendEvent;
    window.kbIdentifyLeadByPhone = identifyByPhone;

    injectPopup();
    setupPhoneCapture();
    setupObservers();
    setupPopupTriggers();
    setupCartTracking();
    setupFloatingActions();
    setupLegacyPopupBlocker();
    setupCartDiscountPopup();
    showPendingCouponNotice();
    setupAutoEvents();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
